export default {
    FiliadoCEP: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "filiado-cep"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/FiliadoCEP.js
// module id = UDeQ
// module chunks = 16